import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import APP_ROUTES from "../../../routers/routeConstants";

const UnlockAdvancedHiringTools = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.unlockAdvancedHiringTools" });

  const navigate = useNavigate();
  const handleGetPremium = () => {
    navigate(APP_ROUTES.PLANS_OVERVIEW);
  };
  const handleViewAllPlans = () => {
    navigate(APP_ROUTES.PLANS);
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("unlockAdvancedHiringTools")}</Typography>
      <Box sx={styles.buttonsContainer}>
        <Button variant="primary-md" sx={styles.getPremiumButton} onClick={handleGetPremium}>
          {t("getPremium")}
        </Button>
        <Button variant="outlined-md" sx={styles.viewAllPlansButton} onClick={handleViewAllPlans}>
          {t("viewAllPlans")}
        </Button>
      </Box>
    </Box>
  );
};

export default UnlockAdvancedHiringTools;

const styles = {
  container: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: "24px", sm: "0" },
    justifyContent: "space-between",
    alignItems: "center",
    padding: "24px",
    borderRadius: "12px",
    background: "linear-gradient(269deg, #9D00EC 0.55%, #1F3693 98.76%)",
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    width: { xs: "100%", sm: "fit-content" },
  },
  getPremiumButton: {
    background: "var(--White, #FFF) !important",
    color: "var(--Black-100, #1C1C1C) !important",
    textWrap: "nowrap",
    width: { xs: "100%", sm: "fit-content" },
  },
  viewAllPlansButton: {
    borderColor: "var(--White, #FFF) !important",
    color: "var(--White, #FFF) !important",
    background: "transparent !important",
    textWrap: "nowrap",
    width: { xs: "100%", sm: "fit-content" },
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--White, #FFF)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
};
